import React from 'react';
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { APISD } from "../../../../../config/apisd";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGauge } from '@fortawesome/free-solid-svg-icons';
import { PulseLoader } from "react-spinners";

const formatDateISO = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const subtractDays = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() - days);
  return next;
};

const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(to right, #ddeaffff 8%, #f4f8ffff 18%, #ddeaffff 33%);
    background-size: 800px 104px;
  }
  .shimmer-select { height: 35px; border-radius: 4px; }
`;

export default function Home() {
  document.title = "Dashboard Absensi";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 780px)' });
  const [loading, setLoading] = useState(false);

  const storageBranchGroping = localStorage.getItem('ysb_branch_id');
  const storageLevel = localStorage.getItem('level');

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);

  // Master data
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataLevel, setGetDataLevel] = useState([]);

  const [loadingSchool, setLoadingSchool] = useState(false);
  const [loadingLevel, setLoadingLevel] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Date range
  const [startDate, setStartDate] = useState(formatDateISO(subtractDays(new Date(), 30)));
  const [endDate, setEndDate] = useState(formatDateISO(new Date()));

  // Attendance summary
  const [attendanceStats, setAttendanceStats] = useState({
    total_siswa: 0,
    total_school_days: 0,
    total_hadir: 0,
    total_sakit: 0,
    total_izin: 0,
    total_alpa: 0,
    total_terlambat: 0,
    persentase_kehadiran: 0,
  });

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
  });

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({ create: 0, read: 0, update: 0, delete: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem('level');
    const storageItems = JSON.parse(localStorage.getItem('role_permission')) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find(item => item.menu?.url === location.pathname);
    if (!foundPermission) navigate('/dashboard');
    else setPermission({ create: foundPermission.create, read: foundPermission.read, update: foundPermission.update, delete: foundPermission.delete });
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(() => ({
    headers: { Authorization: `${token}`, "Content-Type": "application/json" },
  }), [token]);

  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach(c => c.abort());
    };
  }, []);

  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jA = order.findIndex(j => (a.school_name || "").toUpperCase().includes(j));
      const jB = order.findIndex(j => (b.school_name || "").toUpperCase().includes(j));
      return jA - jB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") return schools.filter(s => s.school_code !== "BASEMENT_BEKASI");
    return schools;
  };

  // =========================
  // INIT: Branch + Semester
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    try {
      const [branchRes, semesterRes] = await Promise.all([
        APIMS.get(`/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`, fetchParams),
        // APILA.get(`/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`, fetchParams),
        APIMS.get(`/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`, fetchParams),
      ]);

      if (!isMounted.current) return;

      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);
        if (branches.length > 0) {
          setForm2(prev => ({ ...prev, ysb_branch_id: branches[0].branch_code }));
        }
      }

      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find(s => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2(prev => ({ ...prev, ysb_semester_id: active.id }));
        }
      }
    } catch (err) {
      swal({ title: "Failed", text: err?.response?.data?.message || err.message || "Error", icon: "error" });
    }
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => { fetchInit(); }, [fetchInit]);

  // =========================
  // Fetch sekolah saat cabang berubah
  // =========================
  const fetchSchoolsByBranch = useCallback(async (branchId) => {
    initSchoolDone.current = false;
    initLevelDone.current = false;
    setLoadingSchool(true);
    try {
      const res = await APIMS.get(
        `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
        fetchParams
      );
      if (res?.status === 200) {
        let schools = res.data.data || [];
        if (storageLevel === "developer" || storageLevel === "superadmin") {
          schools = schools.filter(s => s.ysb_branch_id === branchId);
        }
        schools = removeBasementBekasi(schools, branchId);
        schools = sortSchools(schools);
        setGetDataSchool(schools);
        if (schools.length > 0) {
          setGetDataLevel([]);
          setForm2(prev => ({ ...prev, ysb_school_id: schools[0].school_code, ysb_grade_level_id: "" }));
        } else {
          setGetDataLevel([]);
          setForm2(prev => ({ ...prev, ysb_school_id: "", ysb_grade_level_id: "" }));
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      initSchoolDone.current = true;
      setLoadingSchool(false);
      setLoading(false);
    }
  }, [ascending, fetchParams, limit, page, storageLevel]);

  useEffect(() => {
    if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);

  // =========================
  // Fetch tingkatan saat sekolah berubah
  // =========================
  const sortLevels = (levels) => [...levels].sort((a, b) =>
    (a?.name_level || "").localeCompare(b?.name_level || "", "id", { numeric: true, sensitivity: "base" })
  );

  const fetchLevelsBySchool = useCallback(async (schoolId, branchId) => {
    initLevelDone.current = false;
    if (!schoolId) return;
    setLoadingLevel(true);
    try {
      const res = await APIMS.get(
        `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
        fetchParams
      );
      if (res?.status === 200) {
        let levels = res.data?.data || [];
        levels = levels.filter(x => x?.ysb_school_id === schoolId);
        if (branchId) levels = levels.filter(x => x?.ysb_branch_id === branchId);
        levels = sortLevels(levels);
        setGetDataLevel(levels);
        if (levels.length > 0) {
          setForm2(prev => ({ ...prev, ysb_grade_level_id: levels[0].id }));
        } else {
          setForm2(prev => ({ ...prev, ysb_grade_level_id: "" }));
        }
      }
    } catch (err) {
      console.error(err);
      swal({ title: "Failed", text: err?.response?.data?.message || "Gagal mengambil data tingkatan", icon: "error", timer: 3000, buttons: false });
      setGetDataLevel([]);
      setForm2(prev => ({ ...prev, ysb_grade_level_id: "" }));
    } finally {
      initLevelDone.current = true;
      setLoadingLevel(false);
    }
  }, [fetchParams]);

  useEffect(() => {
    if (!form2.ysb_school_id) {
      setGetDataLevel([]);
      setForm2(prev => ({ ...prev, ysb_grade_level_id: "" }));
      return;
    }
    setGetDataLevel([]);
    setForm2(prev => ({ ...prev, ysb_grade_level_id: "" }));
    fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
  }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

  // =========================
  // Filter complete
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    (!loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id)) &&
    !!startDate &&
    !!endDate;

  // =========================
  // Fetch data
  // =========================
  const GetResponseData = useCallback(async () => {
    if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id) return;

    const params = {
      ysb_semester_id: form2.ysb_semester_id,
      level: storageLevel,
      ysb_branch_id: form2.ysb_branch_id,
      ysb_school_id: form2.ysb_school_id,
      start_date: startDate,
      end_date: endDate,
      page: 1,
      limit: 100000,
      ascending: true,
      search: "",
    };
    if (form2.ysb_grade_level_id) params.ysb_grade_level_id = form2.ysb_grade_level_id;

    try {
      const response = await APISD.get('/api/absen-dashboards', { params, ...fetchParams });
      if (response?.status === 200) {
        const s = response.data?.summary || {};
        setAttendanceStats({
          total_siswa: s.total_siswa || 0,
          total_school_days: s.total_school_days || 0,
          total_hadir: s.total_hadir || 0,
          total_sakit: s.total_sakit || 0,
          total_izin: s.total_izin || 0,
          total_alpa: s.total_alpa || 0,
          total_terlambat: s.total_terlambat || 0,
          persentase_kehadiran: s.persentase_kehadiran || 0,
        });
      }
    } catch (error) {
      swal({ title: 'Gagal', text: error?.response?.data?.message || "Gagal mengambil data", icon: 'error' });
    }
  }, [form2, fetchParams, storageLevel, startDate, endDate]);

  // =========================
  // AUTO LOAD
  // =========================
  useEffect(() => {
    const schoolReady = initSchoolDone.current && !loadingSchool && !!form2.ysb_school_id;
    const gradeReady = initLevelDone.current && !loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !schoolReady ||
      !gradeReady
    ) return;

    firstLoadDone.current = true;
    (async () => {
      setIsFetching(true);
      await GetResponseData();
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    loadingSchool,
    loadingLevel,
    getDataLevel.length,
  ]);

  // =========================
  // Handler filter
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm2(prev => ({ ...prev, [name]: value }));
    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  const handleDateChange = (field, value) => {
    if (field === 'start') setStartDate(value);
    else setEndDate(value);
    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    if (loadingSchool || loadingLevel) {
      swal({ title: "Mohon tunggu", text: "Data masih dimuat. Coba lagi sebentar.", icon: "info", timer: 2200, buttons: false });
      return;
    }
    const gradeRequired = getDataLevel.length === 0 ? true : !!form2.ysb_grade_level_id;
    if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !gradeRequired || !startDate || !endDate) {
      swal({ title: "Filter belum lengkap", text: "Pastikan Semester, Cabang, Sekolah, Tingkatan, dan Tanggal sudah dipilih.", icon: "warning" });
      return;
    }
    setHasSearched(false);
    setIsFetching(true);
    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({ title: "Failed", text: err?.response?.data?.message || "Terjadi kesalahan", icon: "error" });
    } finally {
      setIsFetching(false);
    }
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 600,
    color: '#374151',
    marginBottom: 4,
    display: 'block',
  };

  return (
    <>
      <style>{shimmerStyle}</style>
      <div className="body">
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faGauge} />
              </span>
              <h4 className="page-title-text"> Dashboard Absensi</h4>
            </div>
          </div>
          <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/dashboards-main">Beranda</Link>
              </li>
              <li className="custom-breadcrumb-separator">/</li>
              <li className="custom-breadcrumb-item active" aria-current="page">
                Dashboard Absensi
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content">

          {/* FILTER */}
          <div className="mb-4">
            {loading ? (
              <Row>
                {[3, 2, 3, 2, 2, 2, 2].map((md, i) => (
                  <Col key={i} xs={12} sm={6} md={md} className="mb-3">
                    <div className="shimmer" style={{ height: 14, width: 70, borderRadius: 4, marginBottom: 8 }} />
                    <div className="shimmer shimmer-select" style={{ borderRadius: 6 }} />
                  </Col>
                ))}
              </Row>
            ) : (
              <>
                <Row className="mb-2 align-items-end">
                  <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
                    <label style={labelStyle}>Semester</label>
                    <select className="form-control form-control-sm" name="ysb_semester_id" value={form2.ysb_semester_id} onChange={handleChange} style={{ borderRadius: 8 }}>
                      <option value="" hidden>{namaTA} (Semester {namaSmstr})</option>
                      {getDataSemesterMap.map((s, i) => (
                        <option key={i} value={s?.id}>{s?.name_year} (Semester {s?.semester})</option>
                      ))}
                    </select>
                  </Col>
                  <Col xs={12} sm={6} md={2} className="mb-3 mb-md-0">
                    <label style={labelStyle}>Cabang</label>
                    <select className="form-control form-control-sm" name="ysb_branch_id" value={form2.ysb_branch_id} onChange={handleChange} style={{ borderRadius: 8 }}>
                      <option value="" hidden>Pilih Cabang</option>
                      {getDataBranch.map((b, i) => (
                        <option key={i} value={b?.branch_code}>{b?.branch_name}</option>
                      ))}
                    </select>
                  </Col>
                  <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
                    <label style={labelStyle}>Sekolah</label>
                    <select className="form-control form-control-sm" name="ysb_school_id" value={form2.ysb_school_id} onChange={handleChange} disabled={loadingSchool} style={{ borderRadius: 8 }}>
                      <option value="" hidden>{loadingSchool ? "Memuat..." : "Pilih Sekolah"}</option>
                      {!loadingSchool && getDataSchool.map((s, i) => (
                        <option key={i} value={s?.school_code}>{s?.school_name}</option>
                      ))}
                    </select>
                  </Col>
                  <Col xs={12} sm={6} md={2} className="mb-3 mb-md-0">
                    <label style={labelStyle}>Tingkatan</label>
                    <select className="form-control form-control-sm" name="ysb_grade_level_id" value={form2.ysb_grade_level_id} onChange={handleChange} disabled={loadingLevel} style={{ borderRadius: 8 }}>
                      <option value="" hidden>{loadingLevel ? "Memuat..." : "Pilih Tingkatan"}</option>
                      {!loadingLevel && getDataLevel.map((l, i) => (
                        <option key={i} value={l?.id}>{l?.name_level}</option>
                      ))}
                    </select>
                  </Col>
                </Row>
                <Row className="align-items-end">
                  <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
                    <label style={labelStyle}>Start Date</label>
                    <input type="date" className="form-control form-control-sm" value={startDate} onChange={e => handleDateChange('start', e.target.value)} style={{ borderRadius: 8 }} />
                  </Col>
                  <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
                    <label style={labelStyle}>End Date</label>
                    <input type="date" className="form-control form-control-sm" value={endDate} onChange={e => handleDateChange('end', e.target.value)} style={{ borderRadius: 8 }} />
                  </Col>
                  <Col xs={12} sm={6} md={2}>
                    <button
                      onClick={handleCari}
                      disabled={!isFilterComplete}
                      style={{
                        width: '100%',
                        background: !isFilterComplete ? '#94a3b8' : '#eca91aff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 8,
                        padding: '7px 16px',
                        fontSize: 13,
                        fontWeight: 600,
                        cursor: !isFilterComplete ? 'not-allowed' : 'pointer',
                      }}
                    >
                      Cari
                    </button>
                  </Col>
                </Row>
              </>
            )}
          </div>

          {isFetching && (
            <div className="text-center" style={{ padding: "10px 0" }}>
              <PulseLoader color={'#3f5bea'} size={12} />
            </div>
          )}

          {/* SUMMARY CARDS */}
          {hasSearched && !isFetching && (
            <Row className="mb-3 mt-3">
              <Col xs={12} sm={6} md={3} className="mb-3">
                <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#3b82f6', borderRadius: '6px 0 0 6px' }} />
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#3b82f6', textTransform: 'uppercase', letterSpacing: 0.6 }}>Total Siswa</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{attendanceStats.total_siswa}</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>di jenjang ini</div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={3} className="mb-3">
                <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#10b981', borderRadius: '6px 0 0 6px' }} />
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#10b981', textTransform: 'uppercase', letterSpacing: 0.6 }}>Hadir</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{attendanceStats.total_hadir}</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>siswa hadir ≥1 hari</div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={3} className="mb-3">
                <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#ef4444', borderRadius: '6px 0 0 6px' }} />
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#ef4444', textTransform: 'uppercase', letterSpacing: 0.6 }}>Alpa</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{attendanceStats.total_alpa}</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>siswa alpa ≥1 hari</div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={3} className="mb-3">
                <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#f97316', borderRadius: '6px 0 0 6px' }} />
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#f97316', textTransform: 'uppercase', letterSpacing: 0.6 }}>Sakit</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{attendanceStats.total_sakit}</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>siswa sakit ≥1 hari</div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={3} className="mb-3">
                <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#fbbf24', borderRadius: '6px 0 0 6px' }} />
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#fbbf24', textTransform: 'uppercase', letterSpacing: 0.6 }}>Izin</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{attendanceStats.total_izin}</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>siswa izin ≥1 hari</div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={3} className="mb-3">
                <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#8b5cf6', borderRadius: '6px 0 0 6px' }} />
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#8b5cf6', textTransform: 'uppercase', letterSpacing: 0.6 }}>Terlambat</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{attendanceStats.total_terlambat}</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>siswa terlambat ≥1 hari</div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={3} className="mb-3">
                <div style={{ position: 'relative', background: '#fff', borderRadius: 10, padding: 18, boxShadow: '0 6px 18px rgba(15,23,42,0.06)', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: '#06b6d4', borderRadius: '6px 0 0 6px' }} />
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#06b6d4', textTransform: 'uppercase', letterSpacing: 0.6 }}>Persentase Kehadiran</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: '#111827', marginTop: 6 }}>{attendanceStats.persentase_kehadiran.toFixed(2)}%</div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>tingkat kehadiran keseluruhan</div>
                  </div>
                </div>
              </Col>
            </Row>
          )}

        </div>
      </div>
    </>
  );
}
